import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from "@angular/forms";
import { SenhaService } from "./senha.service";
import { ToastrService } from "ngx-toastr";
import { BlockUI, NgBlockUI } from "ng-block-ui";
import { Router } from "@angular/router";
import { Location } from '@angular/common';

@Component({
  selector: 'app-recuperar-senha',
  templateUrl: './recuperar-senha.component.html',
  styleUrls: ['./recuperar-senha.component.css']
})
export class RecuperarSenhaComponent implements OnInit {
  @BlockUI() blockUI: NgBlockUI;

  // No formulário mantemos metodoEnvio por clareza, 
  // mas no envio vamos mapear para 'metodo' conforme seu DTO Java
  recuperarForm = this.fb.group({
    cpfOuEmail: ['', [Validators.required]],
    metodoEnvio: ['EMAIL', [Validators.required]] // Pode ser 'EMAIL', 'EMAIL_ALT' ou 'WHATSAPP'
  });

  constructor(
    private fb: FormBuilder,
    private recuperarSenha: SenhaService,
    private toasterService: ToastrService,
    private router: Router,
    private location: Location
  ) { }

  ngOnInit() {
    this.recuperarForm.get('metodoEnvio')?.valueChanges.subscribe(() => {
      this.recuperarForm.get('cpfOuEmail')?.reset();
    });
  }

  get metodoSelecionado() {
    return this.recuperarForm.get('metodoEnvio')?.value;
  }

  onSubmit(): void {
    if (this.recuperarForm.invalid) {
      this.recuperarForm.markAllAsTouched();
      return;
    }

    this.blockUI.start('Enviando solicitação...');

    // Criamos o objeto exatamente como o RecuperarSenhaDTO.java espera
    const dadosRecuperacao = {
      cpfOuEmail: this.recuperarForm.value.cpfOuEmail!,
      metodo: this.recuperarForm.value.metodoEnvio!
    };

    // Chamamos o serviço passando o objeto único
    this.recuperarSenha.solicitarRecuperacaoSenha(dadosRecuperacao).subscribe({
      next: () => {
        // Lógica para definir a mensagem de sucesso baseada no destino
        let destino = '';

        switch (dadosRecuperacao.metodo) {
          case 'EMAIL':
            destino = 'seu e-mail principal';
            break;
          case 'EMAIL_ALT':
            destino = 'seu e-mail alternativo';
            break;
          case 'WHATSAPP':
            destino = 'seu WhatsApp';
            break;
          default:
            destino = 'o canal selecionado';
        }

        this.toasterService.success(`Solicitação enviada! Verifique ${destino}.`);
        this.redirectTo('login');
      },
      error: (err: any) => {
        let mensagem = 'Erro ao enviar a solicitação. Tente novamente mais tarde.';

        // Se o erro for 400 (Bad Request), o Spring devolve os erros de validação ou BusinessExceptions
        if (err.status === 400) {
          if (Array.isArray(err.error) && err.error[0]?.message) {
            mensagem = err.error[0].message;
          } else if (err.error?.message) {
            mensagem = err.error.message;
          }
        }

        this.toasterService.error(mensagem);
        this.blockUI.stop();
      },
      complete: () => {
        this.blockUI.stop();
      }
    });
  }

  redirectTo(uri: string) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([uri]);
    });
  }

  voltar(): void {
    this.location.back();
  }
}